import React from 'react';
import { CommandBarButton } from 'mini-command-bar-button';
import { getActiveMailListFilterPropsForSelectedView } from '../utils/getActiveMailListFilterPropsForSelectedView';
import {
    getNativeAdShowStatus,
    isGdprAdMarket,
    NativeAdUserFlight,
} from 'mini-mail-nativead-userchecker';
import { isConsumer } from 'owa-shared-start/lib/sessionDiagnostics';
import { MailListFilterButtonProps } from '../schema/MailListFilterButtonProps';
import { observer } from 'mobx-react-lite';
import { onMailListFilterClickCallback } from '../utils/onMailListFilterClickCallback';

const styles = require('./MailListFilterButton.scss');
const classNames = require('classnames/bind').bind(styles);

const MailListFilterButton = (props: MailListFilterButtonProps) => {
    const { selectedTableView, filterRef } = props;

    const bannerView =
        isConsumer() &&
        isGdprAdMarket() &&
        getNativeAdShowStatus() == NativeAdUserFlight.PrebidMobileBannerAd;

    const {
        icon,
        isPressed,
        label,
        ariaLabel,
        activeViewFilter,
    } = getActiveMailListFilterPropsForSelectedView(selectedTableView);

    return (
        <CommandBarButton
            icon={icon}
            onClick={onMailListFilterClickCallback(activeViewFilter, filterRef)}
            ariaLabel={ariaLabel}
            label={label}
            className={classNames(
                {
                    [styles.filterButtonBanner]: bannerView,
                    [styles.filterButton]: !bannerView,
                },
                { isPressed }
            )}
            ref={filterRef}
            ariaHasPopup={activeViewFilter === 'All'}
        />
    );
};

export default observer(MailListFilterButton);
